import environment from 'lib/environment';

export const BILLING_ACCOUNT_ROLES = {
  // @NOTE ROLE_COMMERCE_BILLING_ADMIN role is deprecated
  BILLING_ADMIN: 'ROLE_COMMERCE_BILLING_ADMIN',
  READ_BILLING_ACCOUNT: 'ROLE_CMRC_READ_BILLING_ACCOUNT'
};
export const cybersourceRegionCountryCodes = Object.keys(environment.get('cybersource.regions'));
export const PAYMENT_STATUS_GRACE_RENEWAL = 'GRACE_RENEWAL';
